/* src/app/shared/components/loading/loading-text.component.css */
.container-loading {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 140px;
  background: #fff;
}
.container-loaded {
  padding: 0;
  margin: 0;
  width: 100%;
  background: #fff;
}
.wrapper {
  position: relative;
  width: 20%;
  height: 35%;
  margin: 0 auto;
}
.circle {
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  animation: circle .5s alternate infinite ease;
}
.circle-1 {
  background-color: #302e2b;
  left: 15%;
  animation-delay: .2s;
}
.circle-2 {
  background-color: #8cb7c9;
  left: 45%;
  animation-delay: .3s;
}
.circle-3 {
  background-color: #e3fd64;
  left: 75%;
  animation-delay: .4s;
}
@keyframes circle {
  0% {
    top: 90%;
    height: 5px;
    border-radius: 50px 50px 25px 25px;
    transform: scaleX(1.7);
  }
  40% {
    height: 20px;
    border-radius: 50%;
    transform: scaleX(1);
  }
  100% {
    top: 10%;
  }
}
.shadow {
  width: 20px;
  height: 4px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, .5);
  position: absolute;
  top: 95%;
  transform-origin: 50%;
  z-index: 0;
  left: 15%;
  filter: blur(1px);
  animation: shadow .5s alternate infinite ease;
}
@keyframes shadow {
  0% {
    transform: scaleX(1.5);
  }
  40% {
    transform: scaleX(1);
    opacity: .7;
  }
  100% {
    transform: scaleX(.2);
    opacity: .4;
  }
}
.shadow:nth-child(3) {
  left: 15%;
  animation-delay: .2s;
}
.shadow:nth-child(4) {
  left: 45%;
  animation-delay: .3s;
}
.shadow:nth-child(5) {
  left: 75%;
  animation-delay: .4s;
}
.loading-text {
  margin: 0 auto;
  font-size: 30px;
  font-weight: 400;
  color: #302e2b;
}
.loaded-text-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #4d4e56;
}
.icon-title-message {
  background:
    linear-gradient(
      180deg,
      #e3fd64,
      #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #e3fd64;
  font-size: 18px;
}
.loaded-text-message {
  font-size: 25px;
  font-weight: 400;
  color: #302e2b;
}
@media (max-width: 769px) {
  .container-loading {
    height: 150px;
  }
  .wrapper {
    width: 40%;
    height: 30%;
  }
  .shadow {
    top: 95%;
  }
  .loading-text {
    line-height: 50px;
  }
  .loaded-text-message {
    line-height: 50px;
  }
}
@media (max-width: 575.98px) {
  .container-loading {
    height: 210px;
  }
  .wrapper {
    width: 50%;
    height: 30%;
  }
}
/*# sourceMappingURL=loading-text.component.css.map */
